import { Deserializable } from '../protocols/deserializable';
import { FundType } from './fund-type';

export class InvestmentInstruction implements Deserializable {
  public id!: string;
  public fundId!: number;
  public percentage!: number;
  public fund!: FundType;

  constructor(fundId: number, fund: FundType, percentage: number) {
    this.fundId = fundId;
    this.fund = fund;
    this.percentage = percentage;
  }

  onDeserialize() {
    if (!!this.fund) {
      this.fund = window.injector.Deserialize.instanceOf(FundType, this.fund);
    }
  }
}
